let text = `<div>
<h1 align="center" style="text-align: center">
<b><span style="font-family: 黑体; font-size: 22pt">网站声明</span></b
><b
  ><span style="font-family: 黑体; font-size: 22pt"><o:p></o:p></span
></b>
</h1>
<p class="15" style="margin-left: 21pt; text-indent: 0pt">
<span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  >&nbsp;</span
>
</p>
<p class="15" style="margin-left: 36pt;">
<!--[if !supportLists]--><span
  style="
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 18pt;
    mso-font-kerning: 0pt;
  "
  >一、&nbsp;</span
><!--[endif]--><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 18pt;
    mso-font-kerning: 0pt;
  "
  >隐私声明</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 9pt;
    mso-font-kerning: 0pt;
  "
  >欢迎您使用FSOM的产品和服务！FSOM深知个人信息对您的重要性，将严格遵守法律法规要求采取相应的安全保护措施，致力于保护您的个人信息安全可控。基于此，FSOM制定本《隐私政策》（下称</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  >“</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 9pt;
    mso-font-kerning: 0pt;
  "
  >本政策</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  >/</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 9pt;
    mso-font-kerning: 0pt;
  "
  >本隐私政策</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  >”</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 9pt;
    mso-font-kerning: 0pt;
  "
  >），帮助您充分了解在您使用FSOM产品和服务的过程中，FSOM会如何收集、使用和保护您的个人信息以及您可以如何管理您的个人信息，以便您更好地作出适当的选择。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 9pt;
    mso-font-kerning: 0pt;
  "
  >请您在访问FSOM平台的第一时间或在开始使用FSOM的产品和服务前，务必先仔细阅读和理解本政策，特别应重点阅读FSOM以</span
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 9pt;
    "
    >粗体</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 9pt;
    mso-font-kerning: 0pt;
  "
  >标识的条款，确保您充分理解和同意之后再开始使用。</span
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 9pt;
    "
    >一旦您继续访问FSOM平台或使用FSOM服务的，即表示您已充分理解并同意本政策。如对本政策内容有任何疑问、意见或建议，您可通过平台公布的联系方式与FSOM联系。</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal" style="line-height: 15pt">
<b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 9pt;
      background: rgb(255, 255, 255);
    "
    ><font face="微软雅黑">本隐私政策将帮助您了解以下内容：</font></span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal" style="line-height: 15pt">
<b><span style="font-family: 微软雅黑; font-size: 10pt">1.&nbsp;</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
      background: rgb(255, 255, 255);
    "
    ><font face="微软雅黑">定义</font></span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal" style="line-height: 15pt">
<b><span style="font-family: 微软雅黑; font-size: 10pt">2.&nbsp;</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
      background: rgb(255, 255, 255);
    "
    ><font face="微软雅黑">我们如</font></span
  ></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 12pt;
      background: rgb(255, 255, 255);
    "
    ><font face="微软雅黑">何</font></span
  ></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
      background: rgb(255, 255, 255);
    "
    ><font face="微软雅黑">收集和使用您的信息</font></span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal" style="line-height: 15pt">
<b><span style="font-family: 微软雅黑; font-size: 10pt">3.&nbsp;</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
      background: rgb(255, 255, 255);
    "
    ><font face="微软雅黑">我们如何保护您的信息</font></span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal" style="line-height: 15pt">
<b><span style="font-family: 微软雅黑; font-size: 10pt">4.&nbsp;</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
      background: rgb(255, 255, 255);
    "
    ><font face="微软雅黑">我们如何管理您的信息</font></span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal" style="line-height: 15pt">
<b><span style="font-family: 微软雅黑; font-size: 10pt">5.&nbsp;</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
      background: rgb(255, 255, 255);
    "
    ><font face="微软雅黑">通知与修订</font></span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal" style="line-height: 15pt">
<b><span style="font-family: 微软雅黑; font-size: 10pt">6.&nbsp;</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
      background: rgb(255, 255, 255);
    "
    ><font face="微软雅黑">如何联系我们</font></span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal" style="line-height: 15pt">
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b><span style="font-family: 微软雅黑; font-size: 10pt">1.&nbsp;</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >定义</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >1.1.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >FSOM平台：指含有</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >&nbsp;“hanxinchip.cn”</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >域名及其子域名的网站、</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >APP</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >等。简称</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >&nbsp;“</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >平台</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >”</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >1.2.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >FSOM：指FSOM平台的运营方，即成都FSOM集成技术有限公司。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >1.3.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >1.4.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，具体包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹以及交易信息。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >1.5.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 9pt;
    mso-font-kerning: 0pt;
  "
  >个人非敏感信息：指单独的设备信息、</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  >IP</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 9pt;
    mso-font-kerning: 0pt;
  "
  >地址、日志信息、搜索关键词信息以及其他无法与特定个人直接建立联系的信息或数据。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b
  ><span style="font-family: 微软雅黑; font-size: 10pt"><br /></span></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b><span style="font-family: 微软雅黑; font-size: 10pt">2.&nbsp;</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >我们如何收集和使用您的信息</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 9pt;
    mso-font-kerning: 0pt;
  "
  >我们仅会出于以下目的，</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >收集和使用您</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 9pt;
    mso-font-kerning: 0pt;
  "
  >的个人信息：</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >2.1.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >您须授权我们收集和使用您个人信息的情形</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >平台包括一些核心功能，这些功能包含了实现信息检索与浏览、网上购物所必须的功能及保障交易安全所必须的功能。为了实现上述这些功能，</span
  ></b
><b
  ><span style="font-family: 宋体; font-size: 10pt"
    >我们可能会收集、保存和使用下列与您有关的信息，</span
  ></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >如果您不提供相关信息，您将无法享受我们提供的平台服务。这些功能包括：</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >（</span
  ></b
><b><span style="font-family: 微软雅黑; font-size: 10pt">1</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >）用户注册</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >当您注册平台账户时，您需要至少向我们提供您准备使用的平台账户名、密码、手机号码、电子邮箱（用于验证邮箱），我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >（</span
  ></b
><b><span style="font-family: 微软雅黑; font-size: 10pt">2</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >）产品加购</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >在您访问平台的过程中，您可以选择对感兴趣的符合要求的产品添加至购物车。在您使用上述功能的过程中，我们会收集包括您添加购物车的记录。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >（</span
  ></b
><b><span style="font-family: 微软雅黑; font-size: 10pt">3</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >）下单</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >当您准备对商品进行结算时，平台系统会生成您购买该商品的订单。您需要在订单中至少填写您的收货人姓名、收货地址以及手机号码，如需开具发票的，您还应当填写您的开票信息（包括名称、开户行、账号账号、地址等）。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >（</span
  ></b
><b><span style="font-family: 微软雅黑; font-size: 10pt">4</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >）支付</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  ><font face="微软雅黑"
    >在您下单后，您可以选择与我们合作的第三方支付机构（包括微信支付、支付宝、</font
  ><font face="微软雅黑"
    >PayPal等支付通道）所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的订单号与交易金额信息与这些支付机构共享以实现其确认您的支付指令并完成支付。</font
  ></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >（</span
  ></b
><b><span style="font-family: 微软雅黑; font-size: 10pt">5</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >）客服与售后</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal">
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
    background: rgb(255, 255, 255);
    mso-shading: rgb(255, 255, 255);
  "
  ><font face="微软雅黑"
    >我们的客服和售后功能会使用您的账户信息和订单信息。为保证您的账户安全，我们的客服会使用您的账户信息核验您的身份。当您需要我们提供与您订单信息相关的客服或售后功能时，我们会查询您的订单信息。根据您所要求的服务内容，您可能会在与我们的客服人员沟通时，提供上述信息之外的其他信息，以协助客服人员完成您所要求的服务。</font
  ></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >（</span
  ></b
><b><span style="font-family: 微软雅黑; font-size: 10pt">6</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >）安全保障</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >为提高您使用我们公司及合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或平台相关协议规则的情况，我们可能使用或整合您的用户信息、交易信息、设备信息、服务日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >2.2.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >您个人信息使用的规则</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >我们会根据本隐私政策的约定并为实现平台功能对所收集的个人信息进行使用。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。</span
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >请您了解并同意，在此情况下我们有权使用已经去标识化的信息</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >，包括但不限于用于改善平台的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），</span
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >则此类处理后数据的使用无需另行向您通知并征得您的同意</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >我们会对平台的使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示平台的的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >当我们要将您的个人信息用于本隐私政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >2.3.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >如我们停止运营我们的产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。涉及儿童个人信息的，我们会将停止运营的通知及时告知儿童监护人。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b><span style="font-family: 微软雅黑; font-size: 10pt">3.&nbsp;</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >我们如何保护您的信息</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >3.1.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >3.2.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >我们会采取合理可行的措施以避免收集无关的个人信息。我们只会在达成本协议所述目的所需期限内保留您的个人信息，除非需要延长保留期或应法律法规的允许或要求。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >3.3.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，</span
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >3.4.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >在使用我们产品或服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。</span
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >请您妥善保护自己的个人信息，仅在必要情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络我们，以便我们根据您的申请采取相应措施</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >3.5.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >如上述，我们将使用各种安全技术、程序和制度防止用户个人信息的丢失、不当使用、未经授权的阅览或披露。但您充分理解并同意：由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >3.6.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b><span style="font-family: 微软雅黑; font-size: 10pt">4.&nbsp;</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >我们如何管理您的信息</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >4.1.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >信息的保存及传输</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >您的个人信息将全部被存储于中华人民共和国境内，但以下情形除外：</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >4.1.1.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >法律法规另有明确规定</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >4.1.2.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >获得您的明确授权</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >4.1.3.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >您通过互联网进行跨境交易等个人主动行为</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >针对以上情形，我们会依据本政策及相关法律法规对您的个人信息提供保护。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >4.2.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >信息的查看、更正、补充</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >您可以登录平台自行查看、更正或补充您的信息，包括您的账户信息、地址信息等。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >4.3.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >信息的删除</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >您在我们的平台页面中可以直接清除或删除您的个人信息，包括购物车信息、收货地址信息、足迹信息等。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >4.4.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >改变您授权同意的范围</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >您可以通过删除信息、关闭设备功能以及其他方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >4.5.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >注销您的账户</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >您可以通过平台网站载明的联系方式，告知我们您要注销您的账户，，经我们审核后，我们会为您注销您的账户。当您账户注销之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b><span style="font-family: 微软雅黑; font-size: 10pt">5.&nbsp;</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >通知与修订</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >为给您提供更好的服务以及随着我们业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在平台上发出更新版本并通过公告或以其他适当方式提醒您相关内容的更新，也请您及时了解最新的隐私政策。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  >&nbsp;</span
>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b><span style="font-family: 微软雅黑; font-size: 10pt">6.&nbsp;</span></b
><b
  ><span
    style="
      font-family: 微软雅黑;
      color: rgb(102, 102, 102);
      font-size: 10pt;
    "
    >如何联系我们</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，您可以通过平台网站公布的联系方式与我们联系。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  >&nbsp;</span
>
</p>
<p class="MsoNormal">
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal">
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal">
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 18pt;
    mso-font-kerning: 0pt;
  "
  >二</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 18pt;
    mso-font-kerning: 0pt;
  "
  >、免责声明</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 18pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal">
<span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  >&nbsp;</span
>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b
  ><span style="font-family: 微软雅黑; font-size: 10pt"
    >1. 本站声明</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >1.1.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >本网站旨在为广大用户提供更多的信息，其服务是无偿的。凡以任何方式登陆本网站或直接、间接使用本网站资料者，视为自愿接受本网站声明的约束。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >1.2.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >由于用户将个人密码告知他人或与他人共享注册帐户导致的任何个人资料泄露，本网站不负任何责任。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >1.3.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >当行政机关或司法机关依照法定程序要求本网站披露个人资料时，我们将根据其合法要求或为公共安全之目的提供个人资料。在此情况下之任何披露，本网站均得免责。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  >&nbsp;</span
>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b
  ><span style="font-family: 微软雅黑; font-size: 10pt"
    >2. 网站运营</span
  ></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >2.1.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >本网站如因系统维护或升级而需暂停服务时，将事先公告。若因线路及本公司控制范围外的硬件故障或其它不可抗力而导致暂停服务，于暂停服务期间造成的一切不便与损失，本网站不负任何责任。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >2.2.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营的不可抗力因素造成的个人资料泄露、丢失、被盗用或被窜改等，本网站不承担责任。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 9pt;
    mso-font-kerning: 0pt;
  "
  ><br /></span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<b><span style="font-family: 宋体; font-size: 10pt">3. 法律责任</span></b
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >3.1.&nbsp;</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 微软雅黑;
    mso-bidi-font-family: 宋体;
    color: rgb(102, 102, 102);
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >凡以任何方式登陆本网站或直接、间接使用本网站资料者，视为自愿接受本网站声明的约束。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p
class="MsoNormal"
style="line-height: 15pt; background: rgb(255, 255, 255)"
>
<span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 10pt;
    mso-font-kerning: 0pt;
  "
  >3.2.&nbsp;本声明未涉及的问题参见国家有关法律法规，当本声明与国家法律法规冲突时，以国家法律法规为准。</span
><span
  style="
    mso-spacerun: 'yes';
    font-family: 宋体;
    font-size: 12pt;
    mso-font-kerning: 0pt;
  "
  ><o:p></o:p
></span>
</p>
<p class="MsoNormal">
<span
  style="
    mso-spacerun: 'yes';
    font-family: Calibri;
    mso-fareast-font-family: 宋体;
    mso-bidi-font-family: 'Times New Roman';
    font-size: 10.5pt;
    mso-font-kerning: 1pt;
  "
  >&nbsp;</span
>
</p>
</div>`;

export default text;



// WEBPACK FOOTER //
// ./src/i18n/langs/privacyCN.js